import { useEffect, useState } from 'react'; // , useContext
// import { Link } from 'react-router-dom';
import Profile from '../components/Profile';
import axiosInstance from "../helpers/Axios";
import '../css/youraccount.scss';

interface IProfil {
  contactId: number;
  firstName: string;
  lastName: string;
  birthdate: string;
  address: string;
  street: string;
  postalCode: string;
  city: string;
  phoneNumber: string;
  phoneNumber2: string;
  phoneNumber3: string;
  email: string;
  imageURI: string;
  parents: IProfil[];
  isVisible: boolean;
  dateCreation: Date;
  dateModification: Date;
  children: IProfil[];
}

const defaultProfil: IProfil = {
  contactId: -1,
  firstName: '',
  lastName: '',
  birthdate: '',
  address: '',
  street: '',
  postalCode: '',
  city: '',
  phoneNumber: '',
  phoneNumber2: '',
  phoneNumber3: '',
  email: '',
  imageURI: '',
  parents: [],
  isVisible: true,
  dateCreation: new Date('2024-02-02'),
  dateModification: new Date('2024-02-02'),
  children: []
}


const YourAccount = () => {

  const [profil, setProfil] = useState(defaultProfil);
  const [visible, setVisible] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Lien attendu : /your-account?id=10331&lastName=melchior
    // (l'ancien format avec &firstName=... reste accepté, le prénom est simplement ignoré)
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');
    const lastName = params.get('lastName');

    if (!id || !lastName) {
      setVisible(false);
      setLoading(false);
      return;
    }

    axiosInstance.get(`/contact/${id}-${lastName}`)
      .then(response => {
        if (!response.data) {
          setVisible(false);
          return;
        }
        setProfil(response.data);
      })
      .catch((err) => {
        const error = err.response === undefined ?
          'Server in not reachable'
          : err.response.data;
        console.log('error', error);
        setVisible(false);
      })
      .finally(() => setLoading(false));
  }, []);

  //  console.log("list",list);

  return (
    <div id="courses">
      <div id="title">
        <h1>Votre profil</h1>
      </div>
      <div id="content">
        {
          loading ?
            <p>Chargement en cours...</p>
            :
            visible ?
              <Profile profil={profil} isChild={false} />
              :
              <div>
                <p>Les profils ne sont actuellement pas disponibles</p>
              </div>
        }
      </div>
      <div id="documents">
        Voici les documents :
        <ul>
          <a target="_blank" rel="noopener noreferrer" download href="https://creacirque.be/Documents/Cr%C3%A9acirque%20-%20Droits%20image.pdf">
            <li className="documents__item">Droits à l'image</li>
          </a>
          <a target="_blank" rel="noopener noreferrer" download href="https://creacirque.be/Documents/Cr%C3%A9acirque%20-%20Licences.pdf">
            <li className="documents__item">Licences</li>
          </a>
          <a target="_blank" rel="noopener noreferrer" download href="https://creacirque.be/Documents/Cr%C3%A9acirque%20-%20Informations%20complémentaires.pdf">
            <li className="documents__item">Informations complémentaires</li>
          </a>
        </ul>
      </div>
    </div>
  )
};

export default YourAccount;
